import React from 'react'
import { Button, Modal, Table, Message } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import moment from 'moment'
import {
  postDisableCoupon,
  fetchCouponRecordList,
} from '../../../api/cardManage'
import { round } from '../../../util'

export default class extends React.Component {
  state = {
    loading: false,
    dataList: [],
    isOrder: 0,
    page: 1,
    total: 0,
  }
  componentDidMount() {
    this.getRecordList()
  }

  // 获取购买记录列表
  getRecordList = async () => {
    const { page, isOrder } = this.state
    const { couponItem } = this.props
    this.setState({ loading: true })
    const { data, status, detail } = await fetchCouponRecordList({
      couponId: couponItem.coupon.id,
      isOrder,
      page,
      count: 5,
    })
    this.setState({ loading: false })
    if (status != 1) {
      Message.error(detail)
      return
    }
    const array = [].concat(data.values)
    let newArray = []
    if (array.length > 0) {
      newArray = array.map((item) => {
        const { couponMember, couponMemberBalance } = item
        return {
          ...item,
          couponMember: {
            ...couponMember,
            createTime: moment(couponMember.createTime).format(
              'YYYY-MM-DD HH:mm:ss'
            ),
            updateTime: moment(couponMember.updateTime).format(
              'YYYY-MM-DD HH:mm:ss'
            ),
          },
          couponMemberBalance: {
            ...couponMemberBalance,
            balance:
              couponItem.coupon.typeId == 2
                ? round(couponMemberBalance.balance / 60, 2)
                : round(couponMemberBalance.balance / 100, 2),
          },
        }
      })
    }
    this.setState({
      dataList: newArray,
      total: data.total,
    })
  }

  // 作废卡券
  disabledCoupen = async (id) => {
    const { data, status, detail } = await postDisableCoupon(
      {
        couponMemberId: id,
      },
      this.props.couponItem.club.id
    )
    if (status != 1) {
      Message.error(detail)
      return
    }
    Message.success('操作成功')
    this.getRecordList()
  }

  // 表格排序
  sortTime = () => {
    this.setState(
      {
        isOrder: this.state.isOrder == 0 ? 1 : 0,
        page: 1,
      },
      () => {
        this.getRecordList()
      }
    )
  }

  render() {
    const { loading, dataList, isOrder, page, total } = this.state
    const columns = [
      { title: '手机号', dataIndex: ['member', 'account'] },
      { title: '用户', dataIndex: ['member', 'memberName'] },
      // { title: '购买时间', dataIndex: ['couponMember', 'createTime'] },
      {
        title: () => {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>购买时间</span>
              {isOrder == 0 && (
                <DownOutlined
                  style={{
                    fontSize: '22px',
                    color: '#2D8CFF',
                    cursor: 'pointer',
                  }}
                  onClick={this.sortTime}
                />
              )}
              {isOrder == 1 && (
                <UpOutlined
                  style={{
                    fontSize: '22px',
                    color: '#2D8CFF',
                    cursor: 'pointer',
                  }}
                  onClick={this.sortTime}
                />
              )}
            </div>
          )
        },
        dataIndex: ['couponMember', 'createTime'],
      },
      { title: '余额', dataIndex: ['couponMemberBalance', 'balance'] },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          if (+record.couponMemberBalance.balance == 0) {
            return <span></span>
          }
          return (
            <span>
              <Popconfirm
                title={`是否作废用户“${record.member.memberName}”的该卡券?`}
                onConfirm={() => {
                  this.disabledCoupen(record.couponMember.id)
                }}
                okText="确认"
                cancelText="取消"
              >
                <Button type="primary" danger>
                  作废此券
                </Button>
              </Popconfirm>
            </span>
          )
        },
      },
    ]
    return (
      <Modal
        title="购买记录"
        visible
        width="800px"
        destroyOnClose={true}
        okText="确认"
        onOk={this.props.onCancel}
        onCancel={this.props.onCancel}
      >
        <Table
          rowKey={(record) => record.couponMember.id}
          bordered
          loading={loading}
          columns={columns}
          dataSource={dataList}
          pagination={{
            current: page,
            pageSize: 5,
            total: total,
          }}
          onChange={(page) => {
            this.setState(
              {
                page: page.current,
              },
              () => {
                this.getRecordList()
              }
            )
          }}
        />
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/CardManage/components/historyModal.js